<template>
    <b-navbar toggleable="lg" id='navbar'>
      <router-link :to="{ name: 'ahj-search', query: {} }">
        <b-navbar-brand>
          <img id="oblogo" src="@/assets/ob.png" />
          <h1 class="app-title">AHJ Registry</h1>
        </b-navbar-brand>
      </router-link>

      

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="me-auto navbar-background">
          <!-- left side intentionally slimmer; moved site links into the right-side dropdown -->
        </b-navbar-nav>
        <!-- /23331600579/nav_banner_728x90 -->
        <div v-if="showNavbarAd" id='div-gpt-ad-1765502392567-0' style='min-width: 728px; min-height: 90px;' class="navbar-ad"></div>
        <b-navbar-nav class="ms-auto navbar-background">
          <!-- if logged in show pfp, else show login button -->
          <b-nav-item href="#/register" v-if="!loggedIn">Create Free Account</b-nav-item>
          <!-- <b-nav-item href="#/login" v-if="!loggedIn">Login</b-nav-item> -->
          <b-button id="login-btn" v-if="!loggedIn" @click="$emit('show-login')">Login</b-button>
          <b-nav-item-dropdown right v-if="loggedIn">
              <template #button-content>
                <i class="bi bi-list" style="font-size: 1.5rem;"></i>
              </template>
              <!-- site navigation moved into this dropdown -->
              <b-dropdown-item class='dropdown-item' href="#/ahj-search">Home</b-dropdown-item>
              <b-dropdown-item class='dropdown-item' href="#/about">About</b-dropdown-item>
              <b-dropdown-item class='dropdown-item' href="#/ahj-search/?tutorial=1&restart=true">Tutorial</b-dropdown-item>
              <b-dropdown-item class='dropdown-item' href="#/data-vis">Coverage</b-dropdown-item>
              <b-dropdown-item class='dropdown-item' v-b-modal.my-modal-1 @click='ResetFeedbackForm'>Report a Bug</b-dropdown-item>
              <feedback-form ref="feedbackFormComponent"></feedback-form>
              <b-dropdown-item class='dropdown-item' href="#/APIDoc">API</b-dropdown-item>
              <b-dropdown-item class='dropdown-item' href="#/TOS">Terms of Service</b-dropdown-item>

              <b-dropdown-divider />

              <b-dropdown-item class='dropdown-item' href="#/settings">
              <!-- account setting page -->
                <i class="bi bi-gear icon"></i>
                Account Settings
              </b-dropdown-item>
              <b-dropdown-item class='dropdown-item' href="#/logout">
              <!-- Logout -->
              <i class="bi bi-box-arrow-right icon"></i>
                Sign Out
              </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>

<script>
import FeedbackForm from "../components/FeedbackForm.vue";

// import APIForm from "../components/APIForm.vue";
// import constants from "../constants";
export default {
  model: {
    event: 'event-open-modal'
  },
  data() {
    return {
      // temporary toggle to disable the navbar ad without removing code
      showNavbarAd: true,
    };
  },
  mounted() {
    // set CSS variable on :root to the navbar height so other components can
    // reserve correct space. We keep this constant (110px) so the header
    // doesn't change height during responsive layout shifts.
    this.requestAdDisplay();
    this.updateNavbarHeight();
    window.addEventListener('resize', this.updateNavbarHeight);
    // request GPT ad display when component mounts (skipped if disabled)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateNavbarHeight);
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    Photo() {
      return this.$store.getters.currentUserInfo ? this.$store.getters.currentUserInfo.Photo : "";
    },
    Username() {
      return this.$store.getters.currentUserInfo ? this.$store.getters.currentUserInfo.Username : "";
    }
  },
  methods: {
    updateNavbarHeight() {
      // Publish a fixed navbar height so responsive changes don't cause
      // the header to grow/shrink. This keeps layout stable (space for ad).
      try {
        document.documentElement.style.setProperty('--navbar-height', '110px');
      } catch (e) {
        // best effort - ignore
      }
    },
    ResetFeedbackForm(){
      // Reset the feedback form state (keeps the same helper behavior)
      if (this.$refs.feedbackFormComponent && this.$refs.feedbackFormComponent.ResetModal) {
        this.$refs.feedbackFormComponent.ResetModal();
      }
    },
    openFeedbackModal(){
      // Reset and show the feedback modal programmatically
      this.ResetFeedbackForm();
      if (this.$refs.feedbackFormComponent && this.$refs.feedbackFormComponent.showModal) {
        this.$refs.feedbackFormComponent.showModal();
      }
    },
    ResetAPIForm(){
      if (this.$refs.apiFormComponent && this.$refs.apiFormComponent.ResetModal) {
        this.$refs.apiFormComponent.ResetModal();
      }
    },
    requestAdDisplay() {
      if (!this.showNavbarAd) return;
      window.googletag = window.googletag || { cmd: [] };
      window.googletag.cmd.push(function() {
        window.googletag.display('div-gpt-ad-1765502392567-0');
      });
    }
  },
  components: {
    "feedback-form": FeedbackForm,
    // "component-login": Login
    // "api-form": APIForm,
  },
}
</script>

<style scoped>

 nav {
  font-size: 18px;
  font-style: normal;
  display: flex;
  /* keep items on a single row; don't allow wrapping which increases height */
  flex-wrap: nowrap;
  padding-left: 20px;
  /* border-bottom: 1px solid #dadce0; */
  padding-top: 4px;
  padding-bottom: 4px; /* reduce padding so navbar stays compact */
  /* FIXED height: keep header the same height at all widths (space for ad) */
  height: var(--navbar-height, 110px) !important;
  min-height: unset;
  align-items: center; /* vertically center contents */
  overflow: visible; /* allow dropdown to extend beyond navbar */
  position: fixed; /* pin navbar to top so content sizing below is stable */
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: white;
}

.navbar-brand {
  margin-right: 30px;
  text-decoration: none;
}

.navbar-brand:hover {
  text-decoration: none;
}

a {
  text-decoration: none !important;
}

a:hover {
  text-decoration: none !important;
}

#oblogo {
  margin-top: -8px;

  width: auto;
  height: 50px;
}

.nav-link {
  color: #3b3932 !important;
}

.app-title {
  font-family: "Roboto";
  font-size: 25px;
  font-weight: bold;
  display: inline;
  text-transform: uppercase;
  margin-left: 5px;
}

.icon {
  margin-right: 0.2em;
}

.dropdown-item {
  padding-left: 0.5em !important;
}

.user-photo {
  height: 90%;
  object-fit: cover;
  border-radius: 2rem;
}

#nav-collapse {
  z-index: 1040;
  overflow: visible !important;
}

.navbar-nav {
  overflow: visible !important;
}

/* Ensure dropdown menu doesn't affect navbar layout */
.dropdown-menu {
  position: absolute !important;
  z-index: 3000 !important;
}

/* Prevent dropdown toggle from affecting layout when expanded */
.nav-item.b-nav-dropdown {
  position: static !important;
}

.b-nav-dropdown.dropdown {
  overflow: visible !important;
}

/* Remove focus/active highlight from dropdown toggle */
.b-nav-dropdown .dropdown-toggle:focus,
.b-nav-dropdown .dropdown-toggle:active,
.b-nav-dropdown .dropdown-toggle.focus,
.b-nav-dropdown .dropdown-toggle.active {
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.b-nav-dropdown .nav-link:focus,
.b-nav-dropdown .nav-link:active {
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

/* Remove all button states for dropdown */
.b-nav-dropdown button:focus,
.b-nav-dropdown button:active,
.b-nav-dropdown button:hover,
.b-nav-dropdown button.focus,
.b-nav-dropdown button.active {
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  border: none !important;
}

.b-nav-dropdown.show .dropdown-toggle {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

@media (min-width: 1800px){
  * {
    font-size: 1.3rem;
  }
  nav {
    font-size: 1.3rem;
  }
}

@media (max-width: 990px){
    .navbar-background {
      background-color: rgba(255, 255, 255, 0.9);
  }
}

/* Ad styling: show large leaderboard on wide screens, hide on smaller viewports */
.navbar-ad {
  /* absolutely position the ad inside the fixed navbar so it does not
     affect document flow or increase the navbar height. Center it horizontally. */
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 728px;
  height: 90px;
  box-sizing: border-box;
  margin: 0; /* remove flow margin */
}
.navbar-ad .ad-placeholder{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6e6e6;
  color: #333;
  font-family: Arial, sans-serif;
  font-size: 18px;
  border-radius: 4px;
}

/* Breakpoint behavior:
   - hide branding (logo/title) first when the window narrows
   - keep the ad visible until a smaller width, then hide the ad
*/
@media (max-width: 1200px) {
  /* hide branding first so the ad keeps room */
  .navbar-brand, #oblogo, .app-title {
    display: none !important;
  }
  nav {
    padding-left: 12px;
    padding-right: 12px;
  }
  .ms-auto {
    z-index: 3000;
    position: relative;
  }
  /* shift ad left instead of centering to make room for nav items */
  .navbar-ad {
    left: 20px;
    transform: translateX(0);
  }
}

@media (max-width: 900px) {
  /* at smaller widths hide the ad so header remains compact */
  .navbar-ad {
    display: none !important;
  }
  nav {
    padding-left: 8px;
    padding-right: 8px;
  }
  #login-btn {
    display: inline-block;
    margin-left: 0.5rem;
  }
}

.dot {
  height: 10px;
  width: 10px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 75%;
  top: 5px;
  z-index: 5000;
}
h3{
  position: relative;
  font-size: 10px;
  left:20%;
  top:-1px;
  color: white;
  font-family: "Roboto Condensed";
}
.format{
  width: 3em;
  height: 3em;
  object-fit: cover;
  float: left;
  position: relative;
}

#login-btn {
    /* font-weight: bold;
    width: 60%;
    color: white; */
    /* margin: 1em auto; */
    /* background-color: white !important; */
    color: #3b3932 !important;
    /* padding: 8px; */
    font-size: 18px;
    border: none;
    background: none;
}

/* #navbar-container{
  display: grid;
} */
</style>